import httpRequest from 'httpRequest'
import {
    ProductTaxContract,
    TaxContract,
    UpdateProductTaxContract,
} from 'models'

const TAX_PREFIX = '/location/taxes'

const taxService = {
    getTaxes() {
        return httpRequest.get<TaxContract[]>(TAX_PREFIX)
    },
    getTax(taxID: string) {
        return httpRequest.get<TaxContract>(`${TAX_PREFIX}/${taxID}`)
    },
    createTax(payload: TaxContract) {
        return httpRequest.post(TAX_PREFIX, payload)
    },
    updateTax(taxID: string, payload: TaxContract) {
        return httpRequest.put(`${TAX_PREFIX}/${taxID}`, payload)
    },
    deleteManyTaxes(taxIDs: string[]) {
        return httpRequest.delete(`${TAX_PREFIX}`, {
            params: {
                taxIDs,
            },
        })
    },
    getTaxProducts(includeDepositAndCreditItems: boolean = false) {
        return httpRequest.get<ProductTaxContract[]>(`${TAX_PREFIX}/products`, {
            params: { includeDepositAndCreditItems },
        })
    },
    updateTaxProducts(payload: UpdateProductTaxContract) {
        return httpRequest.put<ProductTaxContract[]>(
            `${TAX_PREFIX}/products`,
            payload,
        )
    },
}

export default taxService
